// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    },
};

// Reszie Suggestion Box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    // Set Width for Suggestion box when opening
    // By default, the width of Suggestion box is equal to the Search box
    var width = searchElement.outerWidth();
    suggestionElement.outerWidth(width);
  
    if (jQ('.fancybox-overlay').length > 0) {
        jQ(suggestionElement).css({
            'position': 'fixed',
            'overflow-y': 'scroll',
            'height': '100px'
        });
    }
};